import type { CrudAppRoutes } from '@common/defs/types';

const prefix = '/notifications';
const Routes: CrudAppRoutes = {
  ReadAll: prefix,
  ReadAllTargeted: prefix + '/mine',
  CreateOne: prefix + '/create',
  UpdateOne: prefix + '/{id}',
  BroadcastOne: prefix + '/{id}/broadcast',
};

export default Routes;
